import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

/**
 * Slider component
 */
export default class Slider extends withBreakpointObserver(Base) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Slider',
    refs: ['slider', 'prev', 'next', 'pagination'],
    options: {
      pagination: {
        type: String,
        default: 'bullets',
      },
      spaceBetween: {
        type: Number,
        default: 0,
      },
      slidesPerView: {
        type: Number,
        default: 0,
      },
      autoWidth: {
        type: Boolean,
        default: false,
      },
      slidesPerGroup: {
        type: Boolean,
        default: false,
      },
      loop: {
        type: Boolean,
        default: false,
      },
    },
  };

  /**
   *
   */
  mounted() {
    const group = this.$options.slidesPerGroup;
    const autoWidth = this.$options.autoWidth;
    const perView = this.$options.slidesPerView > 0 ? this.$options.slidesPerView : 'auto';

    this.slider = new Swiper(this.$refs.slider, {
      modules: [Navigation, Pagination],
      slidesPerView: 'auto',
      grabCursor: true,
      spaceBetween: this.$options.spaceBetween,
      loop: this.$options.loop,
      ...(group && { slidesPerGroup: 1 }),
      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev,
      },
      pagination: {
        clickable: true,
        el: this.$refs.pagination,
        type: this.$options.pagination,
      },
      breakpoints: {
        0: {
          slidesPerView: autoWidth ? 'auto' : 1.2,
        },
        480: {
          slidesPerView: autoWidth ? 'auto' : 2,
          ...(group && !autoWidth && { slidesPerGroup: 2 }),
        },
        640: {
          slidesPerView: autoWidth ? 'auto' : 3,
          ...(group && !autoWidth && { slidesPerGroup: 3 }),
        },
        1024: {
          slidesPerView: autoWidth ? 'auto' : perView,
          ...(group && !autoWidth && perView !== 'auto' && { slidesPerGroup: perView }),
        },
      },
    });
  }
}
